import { createAction } from '@ngrx/store';

export const ResetAllStores = createAction('[App] Reset All Stores');
